export default __webpack_public_path__ + "static/artboard-anim-1-54e79f30a9c6d3263831cc68e2d18469.webm";